import { createContext } from 'react'
import type { Page } from 'client/types/EMagTypes'

export type MagazineContextProps = {
  contentFolder: string
  setContentFolder: (value: string) => void
  pages: Page[]
  setPages: (value: Page[]) => void
  currentActivePuzzleId: string // Set puzzle id
  setCurrentActivePuzzleId: (value: string) => void
  hasCover: boolean
  lastFlippedPageIndex: number
  setLastFlippedPageIndex: (index: number) => void
  flippingPageIndex: number
  setFlippingPageIndex: (index: number) => void
}

export const MagazineContext = createContext<MagazineContextProps>({
  contentFolder: '',
  setContentFolder: null,
  pages: [],
  setPages: null,
  currentActivePuzzleId: '',
  setCurrentActivePuzzleId: null,
  hasCover: true,
  lastFlippedPageIndex: 0,
  setLastFlippedPageIndex: null,
  flippingPageIndex: null,
  setFlippingPageIndex: null,
})
